import { Route, Routes } from "react-router-dom";
import Login from "../Pages/Guest/Login";
import Page404 from "../Pages/404";
import { useAppContext } from "../context/AppContext";
import Dashboard from "../Pages/Auth/Dashboard";
import Blog from "../Pages/Blogs";
import Register from "../Pages/Guest/Register";
import PrivacyPolicy from "../Components/PrivacyPolicy";
import Main from "../Pages/update/Main";
import Detection from "../Pages/Guest/Detection";

export default function Index() {
  const { user } = useAppContext();
  // console.log(userMemo);
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/yolo-detection" element={<Detection />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
}
